import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { SublistRegionTileFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: SublistRegionTileFragment;
  listItemAttributeId: string;
  listAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function SublistRegionTile({
  fragment,
  listItemAttributeId,
  listAttributeId,
  children,
  dispatch,
}: Props) {
  const { t } = useTranslation();

  const listItemAttribute = fragment.attributes.find(
    (a) => a.id === listItemAttributeId,
  );
  assertTypeName(listItemAttribute?.__typename === "ListItemAttribute");

  const listAttribute = fragment.attributes.find(
    (a) => a.id === listAttributeId,
  );
  assertTypeName(listAttribute?.__typename === "ListAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={t("SublistRegionTile.preview", {
        style: t(`ListRegionTile.preview.${listAttribute.listType}`),
        position: listItemAttribute.ordinal,
      })}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
